import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { BLOCKING_ERROR_TYPE } from "@/apis/constants";
import { updateOnboardingStep } from "@/apis/UserOnboardingStepHelper";
import { AccountIssue } from "@/components/Commons/ErrorBanner/AccountIssue";
import { StepBodyStyledText } from "@/components/Commons/StepBodyStyledText";
import { ITS_LIGHT_TEAL, STEP_ID } from "@/components/constants";
import { getRefPageByError } from "@/components/GetSupport/ChatWidget/helper";
import { AppContext } from "@/stores/appStore";
import { ActionType } from "@/stores/constants";

/**
 * Step of showing the Amazon alias that was assigned to the NH.
 */
export default function AmazonUsername(): JSX.Element {
  const { state, dispatch } = useContext(AppContext);

  /**
   * Set the refPage to provide context to IT Support should the new hire initiate
   * a chat with support
   */
  useEffect(() => {
    updateOnboardingStep("D1_ALIAS");

    dispatch({
      type: ActionType.SET_CHAT_SUPPORT_REF_PAGE,
      chatSupportRefPage: "ezo-amazon-username",
    });
  }, []);

  useEffect(() => {
    if (state.amazonUsername) {
      dispatch({
        stepId: STEP_ID.AMAZON_USERNAME,
        type: ActionType.SET_NEXT_BTN_STATUS,
        enableNext: true,
      });
    }
  }, [state.amazonUsername]);

  if (!state.amazonUsername) {
    return (
      <AccountIssue refPage={getRefPageByError(BLOCKING_ERROR_TYPE.NoAlias)} />
    );
  }

  return (
    <Col rowGap="S400">
      <StepBodyStyledText>
        <Text fontWeight="regular" dataTestId="amazonUsernameInfo">
          <FormattedMessage
            id="amazonUsername-expander-body-info"
            values={{
              emailAddress: (
                <Text fontWeight="bold" display="inline">
                  {`${state.amazonUsername}@amazon.com`}
                </Text>
              ),
              username: (
                <Text fontWeight="bold" display="inline">
                  {state.amazonUsername}
                </Text>
              ),
            }}
          />
        </Text>
      </StepBodyStyledText>
      <View
        backgroundColor="color.surface.bg-default"
        padding="S500"
        dataTestId="amazonUsernameView"
      >
        <Row justifyContent="space-evenly">
          <Text fontWeight="bold">
            <FormattedMessage
              id="amazonUsername-expander-body-username"
              values={{
                username: (
                  <Text
                    display="inline"
                    color="color.text.accent-on-bg-default"
                  >
                    {state.amazonUsername}
                  </Text>
                ),
              }}
            />
          </Text>
        </Row>
      </View>
    </Col>
  );
}
